import Vue from 'vue'
import App from './App.vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import materializecss from 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import PieChart from 'vue-pie-chart/src/PieChart.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAndroid, faApple, faWindows } from '@fortawesome/free-brands-svg-icons'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
Vue.use(VueMaterial)
Vue.use(materializecss)
Vue.use(VueAxios, axios)

library.add(faAndroid, faApple, faWindows)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('pie-chart', PieChart)

Vue.filter('thousands', function (value) {
  if (!value) return '0'
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

new Vue({
  render: h => h(App)
}).$mount('#app')
